import AppBar from '@material-ui/core/AppBar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';
import React, { useState } from 'react';
import ClampLines from 'react-clamp-lines';
import { useOrganizationUsersQuery } from '../../generated/graphql';
import { useGlobalFab, useGuestRedirection } from '../../services/Hooks';
import { fetchOrganization } from '../../utils/Utils';
import CreateUser from '../CreateUser/CreateUser';
import CustomModal from '../CustomModal/CustomModal';
import EditUser from '../EditUser/EditUser';
import Loading from '../Loading/Loading';
import Search from '../Search/Search';
import UserDetails from '../UserDetails/UserDetails';
import styles from './UsersListView.module.scss';
import EmptyState from '../EmptyState/EmptyState';

const UsersFilterBar = (props: any) => {
    return (
        <AppBar position="static" color="transparent">
            <Toolbar>
                <Grid container justify="flex-start" alignItems="flex-end" spacing={2}>
                    <Grid item xs={2}>
                        <Search value={props.search} onChange={props.onChange} placeholder="pesquisar nome" />
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}

const UsersList = ({ users }: { users: any }) => (

    <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Description</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {users.map((user: any) => (
                    <TableRow key={user.id}>
                        <TableCell component="th" scope="user">
                            {user.id}
                        </TableCell>
                        <TableCell component="th" scope="user">
                            {user.name}
                        </TableCell>
                        <TableCell align="left" className={styles.Description}>
                            <Tooltip title={user.description}>
                                <span>
                                    {user.description}
                                </span>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

const UserPreview = (props: any) => {
    return (
        <Card className={styles.UserPreview} onClick={() => props.view(props.user)}>
            <CardHeader title={'#' + props.user.user.id} subheader={props.user.user.name} />
            <CardContent>
                <ClampLines
                    text={props.user.organization.name || ''}
                    id={props.user.id}
                    lines={3}
                    ellipsis="..."
                    buttons={false}
                    innerElement="p"
                    className={styles.Description}
                />
            </CardContent>
        </Card>
    );
};

const UsersGrid = ({ users, view }: { users: any, view: any }) => {

    if (users.length === 0) {
        return <EmptyState />
    }

    return (
        <Grid container justify="center" className={styles.UseresGrid}>
            <Grid container item xs={12}>
                &nbsp;
            </Grid>
            <Grid container item xs={10} spacing={4}>
                {users.map((user: any) => (
                    <Grid item xs={3} key={user.id}>
                        <UserPreview user={user} view={view} />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};


const UsersListView = () => {

    useGuestRedirection();

    const [isCreateModalOpen, setCreateModalOpen] = useState(false);
    const [isViewModalOpen, setViewModalOpen] = useState(false);
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [filters, setFilters] = useState({ search: "", view: 'GRID', page: 1, organization: fetchOrganization() });
    const [viewUser, setViewUser] = useState();
    const { data, loading, refetch, error } = useOrganizationUsersQuery({ variables: { ...filters } });

    useGlobalFab(() => setCreateModalOpen(true));

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return <div>Error {error.message}</div>
    }

    const onComplete = () => {
        setCreateModalOpen(false);
        refetch();
    };

    const handleChange = (event: any) => {
        const name = event.target ? event.target.name : 'view';
        const value = event.target ? event.target.value : event.view;
        if (value === '') {
            const newFilters = { ...filters };
            // @ts-ignore
            delete newFilters[name];
            setFilters({ ...newFilters });
        } else {
            setFilters({ ...filters, [name]: "" + value });
        }

    };

    const handlePagination = (event: any, page: any) => {
        setFilters({ ...filters, page });
    };

    const handleViewUser = (process: any) => {
        setViewModalOpen(true);
        setViewUser(process);
    };

    const handleEditIssue = () => {
        setEditModalOpen(true);
    }

    const users = data?.organizationUsers?.results;

    return (
        <>
            <UsersFilterBar filters={filters} onChange={handleChange} />
            {filters.view === 'LIST' ? <UsersList users={users} /> : <UsersGrid users={users} view={handleViewUser} />}
            <Grid container justify="center" className={styles.Pagination}>
                {users && users?.length > 0 && <Pagination count={Math.ceil(data?.organizationUsers?.count ? data?.organizationUsers.count / 25 : 0)} page={filters.page} onChange={handlePagination} />}
            </Grid>
            <CustomModal
                isActive={isCreateModalOpen}
                title="Adicionar Utilizador"
                handleClose={() => setCreateModalOpen(false)}>
                <CreateUser onComplete={onComplete} />
            </CustomModal>
            <CustomModal
                isActive={isViewModalOpen}
                title=""
                showClose={false}
                handleClose={() => setViewModalOpen(false)}>
                <UserDetails process={viewUser}
                    onComplete={() => setViewModalOpen(false)}
                    // @ts-ignore
                    onEdit={handleEditIssue} />
            </CustomModal>
            <CustomModal
                isActive={isEditModalOpen}
                title="Edit Issue"
                handleClose={() => setEditModalOpen(false)}>
                <EditUser
                    process={viewUser}
                    onComplete={() => {
                        refetch();
                        setViewModalOpen(false);
                        setEditModalOpen(false);
                    }}
                />
            </CustomModal>
        </>
    );
};

export default UsersListView;
